import { aiModal11, aiModal12, aiModal13, aiModal3, aiModal4, aiModal5, aiModal6, aiModal_futanari, aiModalAmatue, Rectangle50, Rectangle57, Rectangle63, Rectangle64, Rectangle65, Rectangle66 } from ".";

export const buttonsData = [
    { placeholder: 'Shirtlift', },
    { placeholder: 'Handjob', },
    { placeholder: 'Pussy', },
    { placeholder: 'Missionary', },
    { placeholder: 'Blowjob + Face-swap', },
    { placeholder: 'Handjob + Interracial', },
    { placeholder: 'Huge (Dildo Insertion)', }
];
export const imageData = [
    { src: Rectangle65, alt: 'Rectangle62' },
    { src: Rectangle63, alt: 'Rectangle63' },
    { src: Rectangle64, alt: 'Rectangle64' },
    { src: Rectangle65, alt: 'Rectangle65' },
    { src: Rectangle66, alt: 'Rectangle66' }
];

export const accordionData = [
    {
        title: "What is EROMANTICAI?",
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with "
    },
    {
        title: "What is EROMANTICAI?",
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with "
    },
    {
        title: "What is EROMANTICAI?",
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with "
    },
    {
        title: "What is EROMANTICAI?",
        content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with "
    }
];

export const blogPosts = [
    {
        id: 1,
        title: "Is SeducedAI Safe? A Detailed Guide",
        description: "Sed iaculis leo id nisi laoreet, in elem tum velit fringilla. Phasellus at justo quis orci scelerisque dictum. Sed pharetra nibh vel cursus pellentesque. Morbi odio odio, hendrerit ...",
        image: Rectangle50,
    },
    {
        id: 2,
        title: "Is SeducedAI Safe? A Detailed Guide",
        description: "Sed iaculis leo id nisi laoreet, in elem tum velit fringilla. Phasellus at justo quis orci scelerisque dictum. Sed pharetra nibh vel cursus pellentesque. Morbi odio odio, hendrerit ...",
        image: Rectangle50
    },
    {
        id: 3,
        title: "Is SeducedAI Safe? A Detailed Guide",
        description: "Sed iaculis leo id nisi laoreet, in elem tum velit fringilla. Phasellus at justo quis orci scelerisque dictum. Sed pharetra nibh vel cursus pellentesque. Morbi odio odio, hendrerit ...",
        image: Rectangle50
    },
    {
        id: 4,
        title: "Is SeducedAI Safe? A Detailed Guide",
        description: "Sed iaculis leo id nisi laoreet, in elem tum velit fringilla. Phasellus at justo quis orci scelerisque dictum. Sed pharetra nibh vel cursus pellentesque. Morbi odio odio, hendrerit ...",
        image: Rectangle50
    },
    {
        id: 5,
        title: "Is SeducedAI Safe? A Detailed Guide",
        description: "Sed iaculis leo id nisi laoreet, in elem tum velit fringilla. Phasellus at justo quis orci scelerisque dictum. Sed pharetra nibh vel cursus pellentesque. Morbi odio odio, hendrerit ...",
        image: Rectangle50
    },
    {
        id: 6,
        title: "Is SeducedAI Safe? A Detailed Guide",
        description: "Sed iaculis leo id nisi laoreet, in elem tum velit fringilla. Phasellus at justo quis orci scelerisque dictum. Sed pharetra nibh vel cursus pellentesque. Morbi odio odio, hendrerit ...",
        image: Rectangle50
    }
];

export const Categories = [
    {
        plush: '+',
        title: 'Categories (6)',
    },
    {
        plush: '+',
        title: 'Categories (6)',
    },
    {
        plush: '+',
        title: 'Categories (6)',
    },
    {
        plush: '+',
        title: 'Categories (6)',
    },
    {
        plush: '+',
        title: 'Categories (6)',
    },
    {
        plush: '+',
        title: 'Categories (6)',
    },
]
export const postData = [
    {
        id: 1,
        image: Rectangle57,
        title: "Is SeducedAI Safe?",
        description: "Sed iaculis leo id nisi laoreet, in elem tum velit fringilla. ..."
    },
    {
        id: 2,
        image: Rectangle57,
        title: "Is SeducedAI Safe?",
        description: "Sed iaculis leo id nisi laoreet, in elem tum velit fringilla. ..."
    }
];

export const data = [
    // { img: aiModal8, title: 'Super Realistic Model', model: 'realisticinstav6.safetensors [ecb478bd5e]' },
    {
      img: aiModal5,
      title: "Realistic",
      type: "real",
      model: "influncerv2_p1.safetensors",
      description:
        "This model generates hyper-realistic human images, capturing subtle facial features, natural lighting, and detailed textures that mirror real-world photography. Ideal for lifelike portraits and high-detail renderings",
    },
    {
      img: aiModal6,
      title: "Hentai",
      type: "Anime",
      model: "metrixhentaip.safetensors",
      description:
        "Specialized for creating anime-inspired content with traditional Hentai aesthetics. It maintains bold outlines, vivid colors, and highly stylized character designs suitable for fans of classic and contemporary Hentai art styles.",
    },
    {
      img: aiModal4,
      title: "Enchant",
      type: "real",
      model: "hyperrealisticv6.safetensors",
      description:
        "This model produces images with a hyper-realistic yet magical quality, blending realism with a touch of fantasy. The resulting artwork captures mystical atmospheres, perfect for enchanting portraits or dreamlike scenes with high attention to detail.",
    },
    {
      img: aiModal11,
      title: "Anime HD",
      type: "Anime",
      model: "animeCARTOON_v10.ckpt",
      description:
        "A high-definition anime model optimized for crisp, vibrant, and detailed animation-style images. This model is suited for both fan art and original characters, capturing the essence of Japanese animation with clear lines and expressive colors.",
    },
    {
      img: aiModal12,
      title: "Surreal",
      type: "real",
      model: "realisticinstav6.safetensors",
      description:
        "Focusing on surrealism, this model generates lifelike images with an imaginative twist, merging real-world elements with abstract concepts. Perfect for creative compositions that challenge reality while maintaining a high level of detail.",
    },
    {
      img: aiModal_futanari,
      title: "Futanari",
      type: "Anime",
      model: "metrixhentaip.safetensors",
      description:
        "A anime model optimized to generate futanari images that consists hermaphrodite characters, generally with female bodies plus a male phallus. Extensions is not available on this modal.",
    },
    {
      img: aiModal13,
      title: "Anime 3D",
      type: "Anime",
      model: "bestanimface.safetensors",
      description:
        "This model generates anime-style 3D renderings, providing depth and a unique stylized realism. Ideal for creating anime characters with a modern 3D aesthetic, bringing additional dimension and detail into traditional anime styles.",
    },
    {
      img: aiModal3,
      title: "Photoreal",
      type: "real",
      model: "realisticinstav6.safetensors",
      description:
        "Aiming for photorealism, this model generates highly detailed, lifelike images that closely resemble actual photography. With a focus on capturing fine textures, natural lighting, and realistic expressions, it's ideal for users looking for a true-to-life rendering style.",
    },
    {
      img: aiModalAmatue,
      title: "Amateur",
      type: "amature",
      model: "lazymixRealAmateur_v40.safetensors",
      description:
        "Aiming for photorealism, this model generates highly detailed, lifelike images that closely resemble actual photography. With a focus on capturing fine textures, natural lighting, and realistic expressions, it's ideal for users looking for a true-to-life rendering style.",
    },
    // { img: aiModal1, title: 'Surreal Anime Model', model: 'bestanimface.safetensors' },
    // { img: aiModal2, title: 'Realistic Anime Model', model: 'anniepornbestwithhuman.safetensors' },
    // { img: aiModal7, title: 'Dark Anime Model', model: 'dksAnimeMerge_dksAnimeV10.safetensors' },
  ];


    // Suggestions data
export const suggestions = [
        {
          id: 1,
          line: "1girl, brown hair, (large breasts), straight hair, wearing bra, in a desert, Bokeh",
        },
        {
          id: 2,
          line: "1girl, brown hair, (large breasts), straight hair, wearing bikini, in a casino, motion blur",
        },
        {
          id: 3,
          line: "1 girl, 30 years old, brown hair, (medium breasts), pixie cut, wearing pink dress, in a strip club, bokeh",
        },
        {
          id: 4,
          line: "1 girl, 22 years old, Blonde hair, (large breasts), curly hair, wearing dress, in a cruise ship, bokeh",
        },
      ];